var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryBlockchain32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Blockchain_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Blockchain_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-4",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Blockchain_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,19 L23,19 L23,17 L19,17 L19,19 L13,19 L13,17 L9,17 L9,19 L3,19 L3,13 L9,13 L9,15 L13,15 L13,13 L19,13 L19,15 L23,15 L23,13 L29,13 L29,19 Z M28.975,12.044 L22.991,12.044 C22.425,12.044 22,12.497 22,13.054 L22,14 L20,14 L20,13.054 C20,12.497 19.54,12 18.975,12 L12.991,12 C12.425,12 12,12.443 12,13 L12,14 L10,14 L10,13 C10,12.443 9.575,12 9.009,12 L3,12 C2.435,12 2,12.497 2,13.054 L2,19.082 C2,19.638 2.46,20 3.025,20 L9.009,20 C9.564,20 10,19.647 10,19.082 L10,18 L12,18 L12,18.991 C12,19.557 12.436,20 12.991,20 L18.975,20 C19.54,20 20,19.547 20,18.991 L20,18 L22,18 L22,19.082 C22,19.647 22.436,20 22.991,20 L28.975,20 C29.54,20 30,19.638 30,19.082 L30,13.054 C30,12.497 29.54,12.044 28.975,12.044 L28.975,12.044 Z M27,14.931 L27.069,17 L24.998,17 L24.931,15 L27,14.931 Z M24.931,18 L27.069,18 C27.582,18 28,17.583 28,17.069 L28,14.931 C28,14.417 27.582,14 27.069,14 L24.931,14 C24.418,14 24,14.417 24,14.931 L24,17.069 C24,17.583 24.418,18 24.931,18 L24.931,18 Z M14.998,17 L14.931,15 L17,14.931 L17.069,17 L14.998,17 Z M17.069,14 L14.931,14 C14.418,14 14,14.417 14,14.931 L14,17.069 C14,17.583 14.418,18 14.931,18 L17.069,18 C17.582,18 18,17.583 18,17.069 L18,14.931 C18,14.417 17.582,14 17.069,14 L17.069,14 Z M7,17.002 L5,17.069 L4.931,15 L7,14.931 L7,17.002 Z M7.069,14 L4.931,14 C4.418,14 4,14.417 4,14.931 L4,17.069 C4,17.583 4.418,18 4.931,18 L7.069,18 C7.582,18 8,17.583 8,17.069 L8,14.931 C8,14.417 7.582,14 7.069,14 L7.069,14 Z",
    id: "Blockchain_Category-Icon_32_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryBlockchain32);
export default __webpack_public_path__ + "static/media/Arch-Category_Blockchain_32.f0f4c4ef333e5961fca399a98a15cb40.svg";
export { ForwardRef as ReactComponent };